import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import styles from "./QRCodePop.module.scss";
import logo from "../../../../assets/logo.png";
import { genereateQRCode } from "../../../../api/apiHandler";
import { useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
import Swal from "sweetalert2";
const QRCodePop = ({
  datePresc,
  docData,
  patientData,
  qrCode,
  setQrCode,
  tempPrescription,
  mainPrescription,
  typepres,
  fromEmailMeetingId,
}) => {
  const handleQRCode = () => setQrCode(!qrCode);
  const [patientDataObj, setPatientDataObj] = useState();
  const { meetingId } = useParams();
  const location = useLocation();
  const params = queryString.parse(window.location.search);
  const userRole = localStorage.getItem("user_login_type_role");
  console.log(params, "qerdddd321121", meetingId);
  const [qrCodeUrl, SetQrCodeUrl] = useState(null);
  const [medicineList, setMedicineList] = useState([]);
  function formatDate(presDate) {
    const dateObj = new Date(presDate);
    return `${String(dateObj.getDate()).padStart(2, "0")}/${String(
      dateObj.getMonth() + 1
    ).padStart(2, "0")}/${dateObj.getFullYear()}`;
  }
  let presdate = null;

  // if (typepres == "prescription" && mainPrescription?.length > 0) {
  //   presdate = formatDate(mainPrescription?.[0]?.createdAt);
  // } else if (typepres == "temp-prescription" && tempPrescription?.length > 0) {
  //   presdate = formatDate(tempPrescription?.[0]?.createdAt);
  // }

  const fetchQRCode = async () => {
    let response = await genereateQRCode({
      meeting_id:
        meetingId !== undefined
          ? meetingId
          : params?.meeting_id
          ? params.meeting_id
          : params?.uuid
          ? params?.uuid
          : fromEmailMeetingId,
    });
    response = JSON.parse(response);
    SetQrCodeUrl(response?.data.qrCode);
    setMedicineList(response?.data?.response);
    console.log("qrcodeResponse", response);
    Swal.close();
  };

  useEffect(() => {
    if (qrCode) {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      fetchQRCode();
    }
  }, [qrCode]);

  return (
    <>
      <Modal
        show={qrCode}
        onHide={handleQRCode}
        backdrop="static"
        keyboard={false}
        centered
        size="xl"
        className={`${styles.QRCodePop} QRCodePop`}
        scrollable="true"
      >
        <Modal.Header className="" closeButton>
          <Modal.Title
            style={{ fontSize: 16 }}
            className=" font_500 text-dark  d-flex align-items-center gap-2 mb-0"
          >
            {params?.isPriestMeeting == "true" || userRole == "4"
              ? "Pastoral Report"
              : "View Prescription"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="py-2">
            <div className="bg-light p-2 d-flex align-items-center justify-content-between">
              <p className="m-0 text-dark fw-sbold">
                {medicineList?.[0]?.createdAt
                  ? formatDate(medicineList[0].createdAt)
                  : "No Date Available"}
              </p>
              {qrCodeUrl && (
                <img
                  style={{ height: 80, width: 80 }}
                  src={qrCodeUrl}
                  alt=""
                  className="img-fluid"
                />
              )}
            </div>
          </div>
          <div className="py-2">
            <div className="p-2 rounded border">
              <img
                src={logo}
                alt=""
                style={{ height: 50 }}
                className="img-fluid object-contain"
              />
              <ul className="list-unstyled ps-0 mb-0">
                <li className="py-1 d-flex align-items-center justify-content-between">
                  <p className="m-0 text-dark" style={{ fontSize: 12 }}>
                    Doctor Details
                  </p>
                  <p className="m-0 text-dark" style={{ fontSize: 12 }}>
                    Patient Details
                  </p>
                </li>
                <li className="py-1 d-flex align-items-center justify-content-between">
                  <p className="m-0 text-dark" style={{ fontSize: 12 }}>
                    Dr{" "}
                    {docData?.first_name +
                      " " +
                      docData?.middle_name +
                      " " +
                      docData?.last_name}
                  </p>
                  <p className="m-0 text-dark" style={{ fontSize: 12 }}>
                    {patientData?.first_name +
                      " " +
                      patientData?.middle_name +
                      " " +
                      patientData?.last_name}
                  </p>
                </li>
              </ul>
              <div className="pt-32">
                <p className="m-0 text-dark" style={{ fontSize: 12 }}>
                  {params?.isPriestMeeting == "true" || userRole == "4"
                    ? "Pastoral Report"
                    : "Prescription Details"}
                </p>
                <div className="table-responsive">
                  <table className="table m-0 border">
                    <thead>
                      <tr>
                        <th
                          style={{ fontSize: 12 }}
                          className="bg-light border-light"
                        >
                          {medicineList?.[0]?.pastoral_summary == null &&
                            "Medicine Name"}
                        </th>
                        <th
                          style={{ fontSize: 12 }}
                          className="bg-light border-light text-center"
                        >
                          Qr Code
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {medicineList &&
                        medicineList.length > 0 &&
                        medicineList.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <p
                                className="m-0 text-dark text-muted"
                                style={{ fontSize: 12 }}
                              >
                                {item?.medicine_name}
                              </p>
                            </td>
                            <td>
                              <div className="text-center">
                                {item?.qr_code && (
                                  <img
                                    style={{ height: 80, width: 80 }}
                                    src={item?.qr_code}
                                    alt=""
                                    className="img-fluid mx-auto"
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2">
            <Button
              onClick={handleQRCode}
              className="d-flex align-items-center justify-content-center commonBtn w-100"
            >
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default QRCodePop;
